import { PropertyRef, defineBool, defineEnum } from '@spotify-internal/remote-config-properties';

/**
 * Define properties here and add them into the following array.
 * More on `docs/RemoteConfig/properties.md`
 */
export const ubiTestBool = defineBool({
  name: 'ubiTest',
  description: 'A/A-test to confirm integration towards UBI',
  default: false,
});

// HackWeek 27 - 31 March 2023
export enum FeedbackPositions {
  CURRENT = 'current',
  STICKY = 'sticky',
  POPUP = 'popup',
}

export const feedbackPositionEnum = defineEnum({
  name: 'feedbackPosition',
  description:
    'Position of the feedback widget: current position, sticky position or sticky + show a pop-up when you try to exit of article page view',
  values: FeedbackPositions,
  default: FeedbackPositions.CURRENT,
});

export const properties: Array<PropertyRef> = [ubiTestBool, feedbackPositionEnum];
